import React, { Component } from 'react';
import lang from '../../../lang/index';

export default class ConfirmSuccess extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="popup-wrapper confirm-success">
                <div className="content">
                    <div className="success-result"></div>
                    <section className="success-content">
                        <h1>{ lang.template('提交成功') }</h1>
                        <p>{ lang.template('赶快购买礼物向主播表达心意吧') }</p>
                    </section>
                    <button className="btn-submit"
            		    onClick={this.props.handleConfirm}>{ lang.template('确认') }</button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/orderview/channels/ssl/confirm-success.js